import { Fragment, useState } from "react";
import { Box, IconButton, styled } from "@mui/material";
import { Close, Search } from "@mui/icons-material";
import { topBarHeight } from "app/utils/constant";

// STYLED COMPONENTS
const SearchContainer = styled(Box)(({ theme }) => ({
  top: 0,
  left: 0,
  zIndex: 9,
  width: "100%",
  display: "flex",
  position: "absolute",
  alignItems: "center",
  height: topBarHeight,
  color: theme.palette.text.primary,
  background: theme.palette.primary.main,
  "&::placeholder": { color: theme.palette.text.primary }
}));

const SearchInput = styled("input")(({ theme }) => ({
  width: "100%",
  border: "none",
  outline: "none",
  fontSize: "1rem",
  paddingLeft: "20px",
  height: "calc(100% - 5px)",
  color: theme.palette.text.primary,
  background: theme.palette.primary.main,
  "&::placeholder": { color: theme.palette.text.primary }
}));

export default function MatxSearchBox() {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);

  return (
    <Fragment>
      {!open && (
        <IconButton onClick={toggle}>
          <Search sx={{ color: "text.primary" }} />
        </IconButton>
      )}

      {open && (
        <SearchContainer>
          <SearchInput type="text" placeholder="Search here..." autoFocus />

          <IconButton onClick={toggle} sx={{ mx: 2, verticalAlign: "middle" }}>
            <Close sx={{ color: "text.primary" }} />
          </IconButton>
        </SearchContainer>
      )}
    </Fragment>
  );
}
